<template>
    <div>
        <el-form-item label="Liczba kolumn"
                      :error="errors['columns']">
            <el-select v-model="form.columns"
                       filterable
                       clearable
                       @change="columnsChanged"
                       placeholder="Wskaż liczbę kolumn">
                <el-option v-for="i in maxColumns - 1"
                           :key="i+1"
                           :label="i+1"
                           :value="i+1">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item v-for="column in maxColumns"
                      :key="column"
                      :label="`Kolumna ${column}`"
                      v-if="form.columns && form.columns > column - 1"
                      required
                      :error="errors[addLanguageSuffix(`column_${column}`)]">
            <wyswig-input v-model="form[addLanguageSuffix(`column_${column}`)]"/>
        </el-form-item>
    </div>
</template>
<script>
    export default {
        props: ['form', 'errors'],
        data () {
            return {
                maxColumns: 4
            }
        },
        methods: {
            columnsChanged () {
                if (!this.form.columns) return
                for (let i = this.form.columns + 1; i <= this.maxColumns; i++) {
                    this.form[`column_${i}_pl`] = ''
                    this.form[`column_${i}_en`] = ''
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// ColumnsWidget.vue?3eddd5ca